<template>
    <Home />
</template>

<script>
// @ is an alias to /src
import Home from '@/components/home.vue'

export default {
  name: 'home',
  components: {
    Home
  }
}
</script>
